const HERO_STATS = [
  { value: "1280+", label: "进入观测样本的事件" },
  { value: "9.6万+", label: "粉丝反应样本入库" },
  { value: "6 类", label: "粉圈风向维度追踪" },
];

const HOT_KEYWORDS = ["脱粉", "回踩", "后援会声明", "超话失守", "站姐关站", "路人回流", "塌房 72h"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* subtle background wash */}
      <div className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-primary-100/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -left-24 h-[380px] w-[380px] rounded-full bg-secondary-100/60 blur-3xl"></div>

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-10 px-4 pb-16 pt-28 md:px-6 md:pb-20 md:pt-36 lg:grid-cols-12 lg:gap-8">
        {/* Left copy */}
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-accent-500 animate-radar-ping"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
            </span>
            <span className="text-xs font-medium tracking-wide text-accent-800">LIVE · 粉圈风向实时追踪中</span>
          </div>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.2] text-foreground-950 md:text-5xl">
            塌房之后，
            <br className="hidden sm:block" />
            粉丝如何转身
            <span className="text-primary-600">，舆论怎么降温</span>？
          </h1>

          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-foreground-700 md:text-base">
            从脱粉回踩的万字复盘，到后援会声明的口径摇摆，再到超话失守与站姐关站——「星闻雷达」以匿名化叙事，
            逐帧记录明星塌房后的粉丝立场转变与舆论体温，让你看懂每一次吃瓜背后的真实情绪。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#trending"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-[15px] font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看今日风向
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#reactions"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-[15px] font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              五种粉丝反应
            </a>
          </div>

          {/* stats */}
          <dl className="mt-10 grid max-w-xl grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {HERO_STATS.map((s) => (
              <div key={s.label}>
                <dt className="order-2 mt-1 text-xs leading-snug text-foreground-600">{s.label}</dt>
                <dd className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Right editorial image */}
        <div className="lg:col-span-5">
          <figure className="relative">
            <div className="absolute -inset-3 rounded-2xl bg-gradient-to-br from-primary-100 to-secondary-100 opacity-70"></div>
            <div className="relative overflow-hidden rounded-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20illustration%20for%20celebrity%20scandal%20trending%20page%2C%20warm%20cream%20paper%20background%2C%20layered%20newspaper%20clippings%20and%20polaroid%20frames%2C%20bold%20vermilion%20red%20radar%20waves%20and%20ink%20splashes%2C%20abstract%20vector%20art%20with%20warm%20amber%20accents%2C%20no%20real%20people%2C%20clean%20minimal%20modern%20editorial%20composition&width=900&height=1100&seq=radar-hero-01&orientation=portrait"
                alt="明星塌房后粉丝舆论风向的编辑风插画"
                className="h-[360px] w-full object-cover object-top sm:h-[440px] lg:h-[520px]"
              />
              <div className="absolute inset-x-3 bottom-3 flex flex-wrap items-center justify-between gap-2 rounded-lg bg-foreground-950/80 px-4 py-3 backdrop-blur">
                <div className="flex items-center gap-2 text-background-50">
                  <i className="ri-focus-3-line text-accent-400" aria-hidden="true"></i>
                  <span className="text-xs">本轮观测热点</span>
                </div>
                <span className="text-sm font-medium text-background-50">「粉圈立场三分」进行中</span>
              </div>
            </div>
            <figcaption className="mt-3 text-center text-xs text-foreground-600">
              基于公开讨论的匿名化情绪观察 · 不代表对具体个人的定性
            </figcaption>
          </figure>
        </div>
      </div>

      {/* keyword ticker */}
      <div className="relative border-y border-background-200 bg-background-100/70">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-2 px-4 py-3.5 md:px-6">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-foreground-600">
            <i className="ri-arrow-left-right-line text-primary-500" aria-hidden="true"></i>
            本周风向关键词
          </span>
          <div className="flex flex-wrap items-center gap-2">
            {HOT_KEYWORDS.map((kw) => (
              <a
                key={kw}
                href="#reactions"
                className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-800"
              >
                # {kw}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}